import { ICON } from "../../Icons/Icons"

export const pvtChat = (data) =>
  `<div class="chat-card" id="chatUI-${data.id}" last-timestamp="${(() => {
    const numeric = Number(data.timestamp);
    if (!isNaN(numeric)) {
      return numeric < 1e12 ? numeric * 1000 : numeric;
    }
    return Date.now();
  })()}">
    <div class="avatar pvt">
      <img src="${data.img}" alt="${data.title}">
    </div>
    <div class="chat-details">
      <div class="chat-details-info-holder">
        <div class="chat-title">${data.title}</div>
        <div class="chat-message">${data.lastMessage}</div>
      </div>
    </div>
    <div class="chat-meta">
      <span class="chat-time">${data.timestamp}</span>
      <div class="notification-badge">1</div>
    </div>
  </div>
`

export const sceneChat = (data) => `
  <div class="chat-card" id="chatUI-${data.id}">
      <div class="avatar">
        <img src="${data.img}" alt="Space Chat">
      </div>
      <div class="chat-details">
        <div class="chat-details-info-holder">
          <div class="chat-title">${data.title}</div>
          <div class="chat-message">${data.lastMessage}</div>
        </div>
      </div>
      <div class="chat-meta">
          <span class="chat-time">${data.timestamp}</span>
          <div class="notification-badge">1</div>
      </div>
  </div>
`

export const roomChat = (data) => `
  <div class="chat-card" id="chatUI-${data.id}">
      <div class="avatar">
        <img src="${data.img}" alt="Space Chat">
        <div class="icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8C0 3.58172 3.58172 0 8 0H24V16C24 20.4183 20.4183 24 16 24H0V8Z" fill="#272A31"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1392 4.87349C7.22903 5.63124 5.01928 8.12445 4.6813 11.1818H7.95008C8.13352 8.92102 8.89018 6.75088 10.1392 4.87349ZM13.8608 4.87349C15.1098 6.75089 15.8665 8.92102 16.0499 11.1818H19.3187C18.9807 8.12446 16.771 5.63125 13.8608 4.87349ZM14.4074 11.1818C14.2019 8.96195 13.3661 6.84704 12 5.08702C10.6339 6.84704 9.79811 8.96195 9.59258 11.1818H14.4074ZM9.59258 12.8182H14.4074C14.2019 15.038 13.3661 17.153 12 18.913C10.6339 17.153 9.7981 15.038 9.59258 12.8182ZM7.95008 12.8182H4.6813C5.01928 15.8755 7.22902 18.3687 10.1392 19.1265C8.89018 17.2491 8.13352 15.079 7.95008 12.8182ZM13.8608 19.1265C15.1098 17.2491 15.8665 15.079 16.0499 12.8182H19.3187C18.9807 15.8755 16.771 18.3687 13.8608 19.1265ZM12.0027 21C16.972 20.9985 21 16.9696 21 12C21 7.02943 16.9706 3 12 3C7.02943 3 3 7.02943 3 12C3 16.9697 7.02798 20.9985 11.9973 21C11.9982 21 11.9991 21 12 21C12.0009 21 12.0018 21 12.0027 21Z" fill="white"/>
          </svg>
        </div>
      </div>
      <div class="chat-details">
        <div class="chat-details-info-holder">
          <div class="chat-title">${data.title}</div>
          <div class="chat-message">${data.lastMessage}</div>
        </div>
      </div>
      <div class="chat-meta">
          <span class="chat-time">${data.timestamp}</span>
          <div class="notification-badge">1</div>
      </div>
  </div>
`


export const ChatsPanel = () => `
<!-- Chat Panel -->
<div class="chat-panel">
    <!-- Header -->
    <div class="panel-header">
        <span class="header-title" data-lang="chats">Chats</span>
        <div class="header-actions">
              ${ICON.CLOSE}
        </div>
    </div>

    <div class="chat-body-wrapper">
        <!-- Current Room Section -->
        <div class="section-title" data-lang="current-room">Current room</div>

        <!-- Latest Chats Section -->
        <div class="section-title" data-lang="latest-chats">Latest chats (<span class="chat-count">0</span>)</div>

    </div>
</div>
`
